<template>
    <div class="myFavoriteBox">
        <div class="indexTop clearfix">
            <div class="headBox">
                <div class="headTop">
                    <div class="box">
                        <i class="icon icon_logo" @click="goHomePage()"></i>
                        <a href="http://www.aiyechen.com" target="_blank" title="野尘出品" class="ycCopyright">➲ 野尘出品</a>
                        <div class="searchBox">
                            <ul><!--
                                --><li :class="isSearchTab=='company'?'isActive':''" @click="clickSearchTab('company')">公司</li>
                                <li :class="isSearchTab=='product'?'isActive':''" @click="clickSearchTab('product')">产品</li><!--
                            --></ul>
                            <div class="searchInp">
                                <el-input :placeholder="isSearchTab=='company'?'请输入公司代码、名称':'请输入产品名称，如动力煤、炼焦煤、焦炭等'" v-model="searchKey" class="input-with-select"  @keyup.enter.native="indexSearch()"></el-input>
                                <span @click="indexSearch()" class="btn">搜索</span>
                            </div>

                        </div>
                        <div class="userInfo" @click="goPersonalInfo()">
                            <span class="userNam"> {{ userInfo.userName }}</span>
                            <span class="company" >{{ userInfo.companyName }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="myFavorite">
            <div class="leftBox">
                <div class="title">
                    <span>公司收藏列表</span>
                </div>
                <div class="main">
                  <el-table :data="companyTableData" border  @row-click="goToProductInfoFromCompany">
                      <el-table-column prop="code" label="证券代码" align="center"></el-table-column>
                      <el-table-column prop="name" label="证券简称" align="center"></el-table-column>
                      <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            size="small"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                  </el-table>
                </div>
            </div>
            <div class="rightBox">
                <div class="title">
                    <span>产品收藏列表</span>
                </div>
                <div class="main">
                  <el-table :data="productTableData" border  @row-click="goToProductInfoFromProduct">
                      <el-table-column prop="name" label="产品名称" align="center"></el-table-column>
                      <el-table-column prop="industry" label="所属行业" align="center"></el-table-column>
                      <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            size="small"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                  </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import ssUtil from '@/utils/SStorage'
  export default {
    name: 'myFavorite',
    data() {
        return {
            isSearchTab:'company',  //顶部搜索tab
            isSearchEnd:false,      //是否搜索结束
            searchKey:'',           //关键词搜索
            paramsInfo:{},
            companyTableData: [],
            productTableData: [],
        }
    },
    computed:{...mapState(['userInfo'])},
    created(){
        this.queryMyFavorites()
    },
    methods: {
        //选择搜索tab
        clickSearchTab(str){
            this.isSearchTab = str;
        },
        //关键词搜索
        indexSearch(){
            let urlParams = '';
            if( this.searchKey.trim()==''){
                return;
            }else if( this.isSearchTab == 'product'){
                urlParams = 'productSearch';
            }else if( this.isSearchTab == 'company'){
                urlParams = 'companySearch'
            }
            this.$store.dispatch( urlParams , { keyword: this.searchKey }).then( res => {
                if( res.data.retCode == '000'){
                    this.$store.dispatch( 'indexSearchInfo' , res.data.data)
                    this.isSearchEnd = true;
                    if( res.data.data.length>1){
                        let params = {};
                        params.searchTab = this.isSearchTab;
                        params.searchKey = this.searchKey;
                        params.flag = 'productInfo'
                        this.$store.dispatch('proPageSearchParams',params)
                        this.$router.push({
                            path:'/dashBoard'
                        })
                    }else if(res.data.data.length==1){
                        let retData = res.data.data[0]
                        if(this.isSearchTab == 'product'){
                          let params = {
                              type: 'product',
                              name:retData.productName,
                              industry:retData.industry,
                              productCode:retData.productCode
                          }
                          this.$router.push({name:'productInfo',params:params})
                        }else if(this.isSearchTab == 'company'){
                          let params = {
                              type: 'company',
                              coCode:retData.coCode,
                              securityCode:retData.securityCode,
                              name:retData.securityName
                          }
                          this.$router.push({name:'productInfo',params:params})
                        }
                    }else{
                        Message({
                          message: '没有相关记录',
                          type: 'error',
                          duration: 5 * 1000
                        })
                    }
                }
            })
        },
        //返回首页
        goHomePage(){
            this.$router.push({
                path:'/dashBoard'
            })
        },
        //进入个人中心或者登录页
        goPersonalInfo(){
            //个人中心
            this.$router.push({
                path:'/personal',
            })
        },
        goToProductInfoFromCompany(row,event,column){
            if(column.label=='操作'){
                return
            }
            let params = {
                type: 'company',
                coCode:row.innerId,
                securityCode:row.code,
                name:row.name
            }
            this.$router.push({name:'productInfo',params:params})
        },
        goToProductInfoFromProduct(row,event,column){
            if(column.label=='操作'){
                return
            }
            let params = {
                type: 'product',
                productCode:row.innerId,
                name:row.name,
                industry:row.industry
            }
            this.$router.push({name:'productInfo',params:params})
        },
        queryMyFavorites(){
            this.$store.dispatch('queryMyFavorites').then( res => {
                let companyList = res.data.data.companyList
                if(companyList){
                    this.companyTableData = companyList
                }
                let productList = res.data.data.productList
                if(productList){
                    this.productTableData = productList
                }

            })
        },
        handleDelete(index, row) {
            this.$store.dispatch('removeMyFavorite',{innerId:row.innerId}).then( res => {
                this.$message({
                    message: "删除成功",
                    type: "success",
                    center: true,
                    showClose: false,
                    duration: 600
                });
                this.queryMyFavorites()
            })
        }
    },
    mounted() {},
  }
</script>


<style lang="scss" src="../sass/myFavorite.scss" ></style>



// WEBPACK FOOTER //
// src/view/myFavorite.vue